import { getNumericOperators } from '../../utils/getNumericOperators';
import { getStringOperators } from '../../utils/getStringOperators';
import { CustomCell } from '../../components/custom-cell';

export const TABLE_COLUMNS = [
	{
		headerName: '#',
		field: 'id',
		width: 100,
		minWidth: 100,
		align: 'center',
		headerAlign: 'center',
		type: 'number',
		cellClassName: 'id',
		filterOperators: getNumericOperators(),
		renderCell: params => CustomCell(params),
	},
	{
		headerName: 'Название',
		field: 'name',
		flex: 2,
		filterOperators: getStringOperators(),
		renderCell: params => CustomCell(params),
	},
	{
		headerName: 'Производитель',
		field: 'partner',
		flex: 2,
		filterOperators: getStringOperators(),
		valueFormatter: value => {
			if (!value) {
				return '';
			}

			return value.name;
		},
	},
	{
		headerName: 'Д, см',
		field: 'length',
		flex: 2,
		align: 'center',
		headerAlign: 'center',
		filterOperators: getNumericOperators(),
	},
	{
		headerName: 'Ш, см',
		field: 'width',
		flex: 2,
		align: 'center',
		headerAlign: 'center',
		filterOperators: getNumericOperators(),
	},
	{
		headerName: 'В, см',
		field: 'height',
		flex: 2,
		align: 'center',
		headerAlign: 'center',
		filterOperators: getNumericOperators(),
	},
	{
		headerName: 'Масса пустого, кг',
		field: 'weight',
		flex: 2,
		align: 'center',
		headerAlign: 'center',
		filterOperators: getNumericOperators(),
	},
	{
		headerName: 'Объем, л',
		field: 'volume',
		flex: 2,
		align: 'center',
		headerAlign: 'center',
		filterOperators: getNumericOperators(),
	},
	{
		headerName: 'Кол. в упаковке',
		field: 'package_quantity',
		flex: 2,
		align: 'center',
		headerAlign: 'center',
		filterOperators: getNumericOperators(),
	},
	{
		headerName: 'Кол. на паллете',
		field: 'pallet_quantity',
		flex: 2,
		align: 'center',
		headerAlign: 'center',
		filterOperators: getNumericOperators(),
	},
];

export const NAV_PAGE_LIST = [
	{ text: 'Термоконтейнеры', href: '/thermoboxes' },
	{ text: 'Хладоэлементы', href: '/icepacks' },
];

export const NAV_PAGE_LIST_ICEPACKS = [
	{ text: 'Хладоэлементы', href: '/icepacks' },
	{ text: 'Наполнители', href: '/icepacks_fillers' },
	{ text: 'Состояния', href: '/icepacks_states' },
	{ text: 'Хладоэлементы с наполнителями', href: '/icepacks_filled' },
];

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';
